import * as React from "react"

export function AuthShell({
  children,
  header,
}: {
  children: React.ReactNode
  header?: React.ReactNode
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-page px-4 py-12 text-ink-body">
      <div className="flex w-full max-w-md flex-col items-center gap-6">
        {header}
        <div className="callout w-full">{children}</div>
      </div>
    </div>
  )
}
